// extracted by mini-css-extract-plugin
export default {"wrap":"sub-title_wrap__aGbeo","bottom-line":"sub-title_bottom-line__SC9T8"};